;(function () {
  'use strict';

  /**
   * ワークフロー承認者モーダル
   */
  var approversModal = {
    /**
     * 初期化
     */
    init: function() {
      $('.menu-usage__approval-wrap').each(function (options) {
        var stepId = $(this).find('.js-dialog__approvers').data('step-id');

        var config = $.extend({
          dialog: '.ui-dialog__approvers-' + stepId,          // ダイアログのセレクタ
          sideMargin: 30,                         // 左右の余白 [px]
          openButton: '.js-dialog__approvers-' + stepId // ダイアログの表示ボタン
        }, options);

        if ($('body.sp-viewport').length) {
          // sp版モーダル設定
          $(config.dialog).dialog({
            autoOpen: false,
            draggable: false,
            resizable: false,
            modal: true,
            width: $(window).width() - (config.sideMargin * 2),
            maxHeight: 298,
            height: 'auto',
            open: function () {
              $('body').css('overflow', 'hidden');
              $(config.dialog).css('overflow', 'auto');
            },
            close: function () {
              $('body').css('overflow', 'auto');
            },
            position: {
              my: 'center',
              at: 'center',
              of: window,
            },
            dialogClass: 'dialog--approvers',
            show: 'fade',
            hide: 'fast'
          });
        } else {
          // pc版モーダル設定
          $(config.dialog).dialog({
            autoOpen: false,
            draggable: false,
            resizable: false,
            modal: true,
            width: 300,
            maxHeight: 298,
            height: 'auto',
            open: function () {
              $('body').css('overflow', 'hidden');
              $(config.dialog).css('overflow', 'auto');
            },
            close: function () {
              $('body').css('overflow', 'auto');
            },
            position: {
              my: 'center',
              at: 'center',
              of: window,

            },
            dialogClass: 'dialog--approvers',
            show: 'fade',
            hide: 'fast'
          });
        }

        /**
         * ログインモーダル 表示イベント
         */
        $(config.openButton).on('click', function () {
          $(config.dialog).dialog('open');
          return false;
        });

        /**
         * ログインモーダル 非表示イベント
         */
        $(config.closeButton).on('click', function () {
          $(config.dialog).dialog('close');
          return false;
        });

        //ダイアログ以外の場所をタップしたらダイアログが消える
        $(document).on('click', '.ui-widget-overlay', function () {
          $(config.dialog).dialog('close');
          //ダイアログが消えたら、スクロール可能に
          $(window).off('.noScroll');
        });
      });
    }
  };
  /**
   * DOM content loaded
   */
  $(function () {
    approversModal.init();
  });
}.call(this));
